
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Messages = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Messages</h1>
        <p className="text-muted-foreground">
          Manage your email communications and conversations.
        </p>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle>Email Management</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Email management features will be implemented here.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Messages;
